import React from "react";
import {
  Camera,
  Check,
  CircleAlert,
  LoaderCircle,
  ScanLine,
} from "lucide-react";
import { useTranslation } from "react-i18next";

const statusKeys = {
  SEARCHING: "searching",
  SHOW_ENTIRE_DOCUMENT: "showEntireDocument",
  MOVE_CLOSER: "moveCloser",
  MOVE_AWAY: "moveAway",
  CENTER_DOCUMENT: "centerDocument",
  HOLD_DOCUMENT_FLAT: "holdDocumentFlat",
  HOLD_STEADY: "holdSteady",
  GOOD: "ready",
  RECORDING: "recording",
  PROCESSING: "preparingPreview",
};

// 将几何判断状态转换为用户可理解的提示、图标和颜色；不参与检测决策。
export function DetectionStatus({ status = "SEARCHING", inline = false }) {
  const { t } = useTranslation();
  const key = statusKeys[status] || statusKeys.SEARCHING;
  const isRecording = status === "RECORDING";
  const isProcessing = status === "PROCESSING";
  const isReady = status === "GOOD";
  const isGoodPosition = ["HOLD_STEADY", "GOOD", "RECORDING"].includes(status);
  const isInvalid = [
    "SHOW_ENTIRE_DOCUMENT",
    "MOVE_CLOSER",
    "MOVE_AWAY",
    "CENTER_DOCUMENT",
    "HOLD_DOCUMENT_FLAT",
  ].includes(status);
  const toneClass = isGoodPosition
    ? "document-detection-status--valid"
    : isInvalid
      ? "document-detection-status--invalid"
      : "document-detection-status--neutral";

  return (
    <div
      className={`document-detection-status ${toneClass} ${
        inline
          ? "document-detection-status--inline relative mx-auto flex min-h-8 w-fit max-w-full items-center justify-center gap-2 px-2 text-xs font-semibold"
          : "absolute bottom-2.5 left-1/2 z-20 flex min-h-7 max-w-[calc(100%-1.5rem)] -translate-x-1/2 items-center justify-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-1 text-[11px] font-semibold leading-4 text-white shadow-[0_5px_14px_rgba(0,0,0,0.26)] backdrop-blur-md"
      }`}
      role="status"
      aria-live="polite"
    >
      {isRecording ? (
        <Camera className="size-3.5" aria-hidden="true" />
      ) : isProcessing ? (
        <LoaderCircle className="size-3.5 animate-spin" aria-hidden="true" />
      ) : isReady ? (
        <Check className="size-3.5" aria-hidden="true" />
      ) : isInvalid ? (
        <CircleAlert className="size-3.5" aria-hidden="true" />
      ) : (
        <ScanLine className="size-3.5" aria-hidden="true" />
      )}
      {t(`kyc.camera.${key}`)}
    </div>
  );
}
